import React from 'react';
/**
 * When no iFrame CollectJs fields exist, we should draw them,
 * otherwise, leave the existing fields
 * @returns
 */
function shouldDrawCollectJsFields() {
    const config = window.CollectJS.iframes;
    // is iframe defined in object
    if (config != null && typeof config == 'object' & Object.keys(config).length > 0) {
        const firstElem = config[`${Object.keys(config)[0]}`];
        // is iframe present in the dom
        const isVisible = !!document.querySelector(`iframe#${firstElem.id}`);
        return !isVisible;
    }
    return true;
}

export const configureCJS = (ccValidationCallback, handleTokenCallback) => {
    if (!shouldDrawCollectJsFields()) {
        return;
    }
    window.CollectJS.configure({
        invalidCss: {
            color: "#e74c3c",
            "border-color": "#e74c3c",
        },
        validCss: {
            color: "black",
            "border-color": "#2ecc71",
        },
        placeholderCss: {
            color: "darkgray",
            "background-color": "#ffffff",
        },
        focusCss: {
            color: "black",
            "border-color": "#4681f4",
        },
        customCss: {
            "border-radius": "4px",
            "height": "3rem",
            "border-color": "rgba(0,0,0,0.50)",
            "border-width": "1px",
            "outline-color": "red",
            "font-weight": "400",
            "font-size": "1rem",
            "line-height": "1.4375em",
            "padding": "16.5px 14px",
        },
        fields: {
            ccnumber: {
                title: "Card Number",
                placeholder: "0000 0000 0000 0000",
            },
            ccexp: {
                title: "Card Exipiration",
                placeholder: "00 / 00",
            },
            cvv: {
                title: "CVV Code",
                placeholder: "123"
            }
        },
        validationCallback: function (field, status, message) {
            ccValidationCallback(field, status);
        },
        callback: function (response) {
            handleTokenCallback(response.token);
        },
    });
};

function ccLoading() {
    return (<div>Loading...</div>);
}

function appendCollectJsToDom(resolve, reject) {
    const src = process.env.REACT_APP_COLLECT_JS_CDN;
    const publicNmiKey = process.env.REACT_APP_NMI_PUBLIC_TOKEN;
    const script = document.createElement("script");
    script.src = src;
    script.setAttribute('data-tokenization-key', publicNmiKey);
    script.setAttribute('data-variant', 'inline'); // inject iframes for each field, do not use lightbox overlay
    script.onload = () => resolve();
    script.onerror = () => reject(Error("Failed to load Collect.js"));
    document.head.appendChild(script);
}

function isCollectJsLoaded() {
    return !!document.querySelector("script[src*='Collect.js']");
}

async function loadCollectJs(resolve) {
    return new Promise((resolve, reject) => {
        if (isCollectJsLoaded()) {
            resolve();
            return;
        }
        appendCollectJsToDom(configureCJS, reject);
    });
}

export function CcComponent({ children }) {
    let isReady = false;
    try {
        loadCollectJs(configureCJS);
        isReady = true;
    } catch {
        return (<div>Error...</div>);
    }

    if (isReady) {
        return children;
    }

    return ccLoading();
}